import React, { useState, useEffect } from "react";
import left1 from "../src/topseller/left1.webp";
import left2 from "../src/topseller/left2.jpg";
import left3 from "../src/topseller/left3.webp";
import left4 from "../src/topseller/left4.webp";
import left5 from "../src/topseller/left5.jpg";
import left6 from "../src/topseller/left6.webp";
import left7 from "../src/topseller/left7.webp";
import left8 from "../src/topseller/left8.webp";
import left9 from "../src/topseller/left9.webp";
import left10 from "../src/topseller/left10.webp";
import left11 from "../src/topseller/left11.jpg";
import left12 from "../src/topseller/left12.webp";
import left13 from "../src/topseller/left13.webp";
import left14 from "../src/topseller/left14.jpg";
import left15 from "../src/topseller/left15.webp";
import line from "../src/images/Thanshiq/line.svg"
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import boxs from "../src/images/Thanshiq/Pickup/giftBox.webp"
import { getProduct, orderStatus } from '../src/api/ProductApi';
import { currentRegister } from 'utility/Constant';
import { getBranchId } from "./utility/HeaderConfig";
import { useNavigate } from "react-router-dom";
import Noimg from "../src/images/no_img.jpg";
import {
  deleteCustomerLike,
  createCustomerLike,
  createCustomerWish,
  deleteCustomerWish,
} from "../src/api/Like&WishCountApi";
import bracelets from "../src/images/Thanshiq/resdiamond/diamondBangle.jpg"
import { useCartContext } from "context/UseCartContext";
import { getCustomerId } from "./utility/HeaderConfig";
import nextImage from "../src/images/Thanshiq/slider-arrow-next.svg"
import prevImage from "../src/images/Thanshiq/slider-arrow-prev.svg"


function ImageCarousel() {
  const images = [left1, left2, left3, left4, left5, left6, left7, left8, left9, left10, left11, left12, left13, left14, left15];
  // const [currentIndex, setCurrentIndex] = useState(0);
  // const imagesPerSlide = 4; 

  const history = useNavigate();
  const [loading, setLoading] = useState(true);
  const { dispatch } = useCartContext();
  useEffect(() => {
    Promise.all([
      getOrderStatusSale(),
      getOrderStatusTransfer(),
      getOrderStatusSold()
    ])
      .then((result) => {
        getBestsellerData(result[0], result[1], result[2]);
      })
      .catch((err) => console.error(err));
    //eslint-disable-next-line
  }, []);

  const getOrderStatusSale = () => {
    return orderStatus({ orderStatusName: "sale" })
      .then((data) => {
        return data.response[0].id;
      })
      .catch((err) => console.error(err));
  }

  const getOrderStatusTransfer = () => {
    return orderStatus({ orderStatusName: "Transferred" })
      .then((data) => {
        return data.response[0].id;
      })
      .catch((err) => console.error(err));
  };

  const getOrderStatusSold = () => {
    return orderStatus({ orderStatusName: "Sold" })
      .then((data) => {
        return data.response[0].id;
      })
      .catch((err) => console.error(err));
  };

  const getBestsellerData = (
    orderSaleStatus,
    orderTransferStatus,
    orderSoldStatus
  ) => {
    setLoading(true);
    getProduct(10, {
      branch: getBranchId(),
      productLabel: 'BestSellers',
      removeNTP: 'NTP-',
      removeHP: 'HP-',
      beforeCreatedAt: currentRegister(),
      sortType: true,
      statusId: `${orderSaleStatus},${orderTransferStatus},${orderSoldStatus}`,
      demoStatus: "Demo_Completed,Demo_Cancelled,Available_For_Demo",
    })
      .then((data) => {
        setBestSellerProduct(data.response.content);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
      })
  }
  const wishCountFunc = (product) => {
    if (getCustomerId() && getCustomerId() !== "onlinepayment") {
      const productId = product.productId ? product.productId : product.id;
      setWishState((prevState) => ({
        ...prevState,
        [productId]: !prevState[productId], // Toggle only for the clicked product
      }));

      if (wishState[productId]) {
        const deletWish = `customerId=${getCustomerId()}&productId=${productId}`;
        deleteCustomerWish(deletWish);
      } else {
        const createWish = `customerId=${getCustomerId()}&productId=${productId}&remark=liked`;
        createCustomerWish(createWish);
      }
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };

  const likeCountFunc = (product) => {
    if (getCustomerId() && getCustomerId() !== "onlinepayment") {
      const productId = product.productId ? product.productId : product.id;
      setLikeState((prevState) => ({
        ...prevState,
        [productId]: !prevState[productId], // Toggle only for the clicked product
      }));

      if (likeState[productId]) {
        const deletLike = `customerId=${getCustomerId()}&productId=${productId}`;
        deleteCustomerLike(deletLike);
      } else {
        const createLike = `customerId=${getCustomerId()}&productId=${productId}&remark=liked`;
        createCustomerLike(createLike);
      }
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };

  const items = [
    { id: 1, img: left1, name: "Contemporary Chic Diamond Drop Earrings", price: "₹73226" },
    { id: 2, img: left2, name: "Leafy Sparkle Diamond Mangalsutra ", price: "₹ 21,205" },
    { id: 3, img: left3, name: "Rosy Reverie Diamond Hoop Earrings", price: "₹62891" },
    { id: 4, img: left4, name: "Teardrop Diamond Stud Earrings", price: "₹25352" },
    { id: 5, img: left5, name: "Sophisticated Diamond Ring", price: "₹55913" },
    { id: 6, img: left6, name: "Starry Smiles Diamond Necklace", price: "₹ 47077" },
    { id: 7, img: left7, name: "Serene Snowflake Gold and Diamond Nose Pin", price: "₹ 14324" },
    { id: 8, img: left8, name: "Radiant Swirl Diamond Mangalsutra", price: "₹66149" },
    { id: 9, img: left9, name: "Circular Diamond Pendant", price: "₹64342" },
    { id: 10, img: left10, name: "Hearts Aglow Diamond Necklace", price: "₹ 37371" },
    { id: 11, img: left11, name: "Leafy Sparkle Diamond Mangalsutra", price: "₹40000" },
    { id: 12, img: left12, name: "Blooming Flower Diamond Pendant and Earrings Set", price: "₹ 38990" },
    { id: 13, img: left13, name: "Playful Paws Diamond Pendant and Earrings Set.", price: "₹ 38592" }
  ];
  const [likeState, setLikeState] = useState({});
  const [wishState, setWishState] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const imagesPerSlide = 4;

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1));
  };

  const [bestSellerProduct, setBestSellerProduct] = useState([]);

  const toPascalCase = (text) => {
    if (!text) return ''; // or return some default value like 'N/A'

    return text
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };


  return (
    <div style={{ textAlign: "center", }}>

      <div className="text-center p-2 "  >
        <div className="d-flex justify-content-center align-items-center p-1">
          {/* <img src={boxs} style={{ width: "100%", maxWidth: "1200px", height: "360px" }} alt="Gift Box" /> */}
        </div>
        <div>
          <h1 className="text-4xl md:text-3xl sm:text-2xl HeadLine mb-2 ">
            Top Sellers
          </h1>
        </div>
        <div>
          <small className="text-lg jewellery md:text-base sm:text-sm text-gray-600 ">
            Explore our most loved products
          </small>
        </div>

        <img src={line} alt="Separator Line" className="mx-auto mt-2" style={{ width: "1200px", marginTop: "-80px" }} />
      </div>


      <div id="carousel-container"  style={{marginTop: "-40px"}} className="container py-4 position-relative">
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          navigation={{
            nextEl: "#swiper-button-next",
            prevEl: "#swiper-button-prev",
          }}
          pagination={{ clickable: true }}
          modules={[Navigation, Pagination]}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
          }}
          className="mySwiper"
        >
          {bestSellerProduct.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="card shadow-sm border-0">
                <img
                  onClick={() =>
                    history("/BestSellingComponent", {
                      state: { category: item },
                    })
                  }
                  src={item.images === "Image_Not_Available" || item.images === "-" || item.images === null || item.images === "@#@"
                    ? bracelets
                    : item.images.split("@#@")[0]}
                  alt={item.category}
                  className="card-img-top img-fluid"
                  style={{ height: "280px", width: "260px", objectFit: "cover", borderRadius: "15px" }}
                />
                <div id="subProductCate" className="card-body d-flex justify-content-start">
                  <h5 onClick={() =>
                    history("/BestSellingComponent", {
                      state: { category: item },
                    })
                  } className="card-title ">{toPascalCase(item.category)}</h5>
                  <p className="card-text text-muted mb-2">
                    {item.price}{" "}
                    <span className="text-decoration-line-through text-secondary">
                      {item.originalPrice}
                    </span>
                  </p>

                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div
          id="swiper-button-prev"
          className="swiper-button-prev-custom position-absolute top-50 start-0 translate-middle-y"
          aria-label="Previous slide"
        >
          <img src={prevImage} />

        </div>
        <div
          id="swiper-button-next"
          className="swiper-button-next-custom position-absolute top-50 end-0 translate-middle-y"
          aria-label="Next slide"
        >
          <img src={nextImage} />
        </div>
      </div>


      <div style={{ marginTop: "10px" }}>
       
      </div>
    </div>
  );
}

export default ImageCarousel;